import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AsyncPipe, LowerCasePipe, NgForOf, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipelineSelectorComponent } from './pipeline-selector.component';
import { MatOptionModule } from '@angular/material/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

@NgModule({
  declarations: [PipelineSelectorComponent],
  imports: [
    AsyncPipe,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    NgForOf,
    NgIf,
    TranslateModule,
    GalaxyFormFieldModule,
    LowerCasePipe,
  ],
  exports: [PipelineSelectorComponent],
})
export class PipelineSelectorModule {}
